<div class="events-tab mopView">
  <div class="events-filter-row">
    <mat-chip-listbox class="time-range-chips" aria-label="DatePicker">
      <mat-chip-option (click)="setStartTime('1h')"  [selected]="dateFilter === '1h'">1h</mat-chip-option>
      <mat-chip-option (click)="setStartTime('6h')"  [selected]="dateFilter === '6h'">6h</mat-chip-option>
      <mat-chip-option (click)="setStartTime('24h')" [selected]="dateFilter === '24h'">24h</mat-chip-option>
      <mat-chip-option (click)="setStartTime('3d')"  [selected]="dateFilter === '3d'">3d</mat-chip-option>
      <mat-chip-option (click)="setStartTime('7d')"  [selected]="dateFilter === '7d'">7d</mat-chip-option>
    </mat-chip-listbox>
  </div>
  <div class="events-content-row">
    <div class="cardStack">
      <app-mop-timeline
        [edgeRouterId]="edgeRouter?.id || edgeRouter?.nfId"
        [endTime]="endTime"
        [endpointId]="endpoint?.id"
        [networkId]="currentNetwork.id"
        [startTime]="startTime"
      ></app-mop-timeline>
    </div>
    <div class="cardStack">
      <app-network-metrics-events-dash
        [dateFilter]="dateFilter"
        [edgeRouterId]="edgeRouter?.id"
        [endpointId]="endpoint?.id"
        [networkId]="currentNetwork.id"
      ></app-network-metrics-events-dash>
    </div>
  </div>
</div>
